import { ENV } from "../utils";

// Paso entre productos Sustemia (Sustentable ↔ SH) sin volver a loguearse.
// Ver server/utils/integration.js.
export class Integration {
  baseApi = ENV.BASE_API;

  // Datos de la otra app para el botón "Ingresar con ..." del login.
  // Endpoint público; si falla, simplemente no se muestra el botón.
  async getPeerInfo() {
    try {
      const response = await fetch(`${this.baseApi}/integration/peer`);
      if (response.status !== 200) return { enabled: false };
      return await response.json();
    } catch (error) {
      return { enabled: false };
    }
  }

  // Devuelve la URL de la otra app con un token de traspaso de un solo uso.
  async handoff(accessToken) {
    const response = await fetch(`${this.baseApi}/integration/handoff`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  // Roles de la otra app para elegir con cuál entra un usuario. Devuelve
  // { enabled: false } si la empresa no la tiene contratada.
  async getPeerRoles(accessToken, companyId) {
    const query = companyId ? `?company=${companyId}` : "";
    const response = await fetch(`${this.baseApi}/integration/peer-roles${query}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  // Habilita/saca el acceso de un usuario a la otra app y su rol allá.
  // data: { userId | email, enabled, roleName }
  async setUserAccess(accessToken, data) {
    const response = await fetch(`${this.baseApi}/integration/user-access`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  // ── Pantalla de Integraciones (solo master) ──

  async adminRequest(accessToken, path, method = "GET") {
    const response = await fetch(`${this.baseApi}/integration/admin/${path}`, {
      method,
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  getAdminOverview(accessToken) {
    return this.adminRequest(accessToken, "overview");
  }

  // params: { company, type, page, limit }
  getAdminEvents(accessToken, params = {}) {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    ).toString();
    return this.adminRequest(accessToken, `events${query ? `?${query}` : ""}`);
  }

  // Revisión de datos: compara empresas, sitios y usuarios con la otra app.
  getComparison(accessToken) {
    return this.adminRequest(accessToken, "comparison");
  }

  retryPending(accessToken) {
    return this.adminRequest(accessToken, "retry", "POST");
  }

  syncCompany(accessToken, companyId) {
    return this.adminRequest(accessToken, `companies/${companyId}/sync`, "POST");
  }

  // Vincula las cuentas de la empresa que ya existían en las dos apps (mismo email).
  linkAccounts(accessToken, companyId) {
    return this.adminRequest(accessToken, `companies/${companyId}/link-accounts`, "POST");
  }

  unlinkAccount(accessToken, userId) {
    return this.adminRequest(accessToken, `users/${userId}/unlink`, "POST");
  }

  // Canjea el token que trajo la otra app por una sesión de esta.
  async exchange(token) {
    const response = await fetch(`${this.baseApi}/integration/sso/exchange`, {
      method: "POST",
      credentials: "include", // el servidor setea la cookie httpOnly de refresh
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
